import { render, staticRenderFns } from "./staffAttendanceDetail.vue?vue&type=template&id=c1011996&scoped=true"
import script from "./staffAttendanceDetail.vue?vue&type=script&lang=js"
export * from "./staffAttendanceDetail.vue?vue&type=script&lang=js"
import style0 from "./staffAttendanceDetail.vue?vue&type=style&index=0&id=c1011996&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1011996",
  null
  
)

export default component.exports